jQuery( document ).ready( function( $ ) {
    
    /**
     * Init emergence library
     */ 
    emergence.init({
      reset: false,
      elemCusion: .99,
    });
    
    /**
     * Init Fit Frame js
     */
    function fitFrameInit(){
        $('.main-content').fitFrame();
    }
    //fitFrameInit();
    
    /*
     $('#mobile_nav_trigger').on('click', function(e){
            e.preventDefault();
           $('#mobile-nav-wrapper').show();
            $('#mobile-nav').show();
    }); 
    $('#mobile_nav_close_trigger').on('click', function(e){
            e.preventDefault();
            $('#mobile-nav-wrapper').hide();
            $('#mobile-nav').hide();
    }); 
    */
    
    /**
     * Add class to mobile_nav_trigger when clicked
     */
    $('#mobile_nav_trigger').on('click', function(e){
        e.preventDefault();
        if($(this).hasClass('open')){
        $('#mobile-nav-wrapper').hide();
        $('#mobile-nav').hide();
        }else{
        $('#mobile-nav-wrapper').show();
        $('#mobile-nav').show();   
        }
        
        $(this).toggleClass('open');
    });

    /**
     * Set cookie for site notification dismissal
     */
    if ($.cookie('site_note_close') != 'true') {
      $('.site-notification').removeClass('d-none');

      $('.site-note-close').click(function() {
        $.cookie('site_note_close', 'true', { expires: 10, path: '/' }); 
      });
    } else if ($.cookie('site_note_close') === 'true') {        
    };     
  
  
    /**
     * Default Slick Slider Example
     */
    $('.slick-slideshow').slick({
      dots: true,
    });
    
    
    /**
    Force Telephone url to not break
    */
    $('a[href^="tel:"]').each(function(index, element) {
        var this_phone = $(this).html();
        var this_phone_wrapped = '<span style="white-space:nowrap;">' + this_phone + '</span>';
        $(this).empty().html(this_phone_wrapped);
    });

    /**
     * Smooth Scroll Hashed Links
     * This will scroll to link on same page
     * Or will smoothly scroll to a hashed section on another page after click
     */

    $(function() {
      // your current click function
      // select all links with hashes, remove if don't link to anything (:not)
      // this is for same page hashed links
      $('a[href*=\\#]:not([href=\\#])').on('click', function() {
          if (!$(this).parents('ul').hasClass('nav-tabs')) {
              var target = $(this.hash);
              // if target.length is 0, set target equal to the name attribuite with hash as value
              target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
              // smooth scroll to the target id
              if (target.length) {
                  $('html,body').animate({
                      scrollTop: target.offset().top
                  }, 1000);
                  return false;
              }
          }
      });

      // check if the window location (URL) has a hash in it
      // smoothly scroll to that location
      if(window.location.hash) {
          var target = $(window.location.hash);
          // if target.length is 0, set target equal to the name attribuite with hash as value
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          // smooth scroll to the target id
          $('html, body').delay(1000).animate({
            scrollTop: $(target).offset().top + 'px'
          }, 1000);
          return false;
      }

    });
    
    

} );
